import React, { useState } from "react";
import styled from "styled-components";
import { useInterval } from "../hooks/use-interval";

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  margin: 50px 0 0 0;
  min-height: ${(props) =>
    props.large ? "calc(144px + 40vw)" : "calc(144px + 20vw)"};
`;

const Image = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: opacity 1000ms ease;
  width: 100%;
`;

const Content = styled.div`
  color: ${(props) => props.theme.colours.white};
  padding: 0 30px;
  text-shadow: rgb(0, 0, 0) 0px 0px 10px;
  z-index: 10;
`;

export const Hero = (props) => {
  const [activeImage, setActiveImage] = useState(0);
  const imagesLength = props.images.length;

  useInterval(() => setActiveImage((activeImage + 1) % imagesLength), 5000);

  const renderImages = props.images.map((image, i) => {
    const isVisible = activeImage === i;
    return (
      <Image
        key={i}
        style={{ backgroundImage: `url(${image})`, opacity: isVisible ? 1 : 0 }}
      />
    );
  });

  return (
    <Wrapper large={props.large}>
      {renderImages}
      <Content>{props.children}</Content>
    </Wrapper>
  );
};
